module.exports = __webpack_public_path__ + "static/media/notifications_settings.31518e58.svg";